export default __webpack_public_path__ + "static/media/icon-search.c27ad31d.svg";